import { useLanguage } from "../i18n/LanguageContext";
import PdfModalApp from "./PdfModal";
import BadgesModal from "./BadgesModal";

export default function EducationItem({ education, degree = false }) {
  const { t } = useLanguage();
  const {
    date,
    icon,
    jobTitle,
    title,
    companyName,
    link,
    subTitle,
    skills,
    projects,
    showCertificate,
    certificatePath,
    showBadges,
    badges,
  } = education;
  return (
    <article className={`learning-entry${degree ? " learning-degree" : ""}`}>
      <div className="learning-logo">{icon}</div>
      <div className="learning-content">
        <p className="learning-date">
          <bdi>{date}</bdi>
        </p>
        <h3>{jobTitle || title}</h3>
        <p className="learning-provider">
          {link ? (
            <a href={link} target="_blank" rel="noreferrer">
              {companyName}
            </a>
          ) : (
            companyName
          )}
        </p>
        {(subTitle || skills || projects) && (
          <details className="learning-details">
            <summary>{t("learning.details")}</summary>
            {subTitle && <p className="learning-description">{subTitle}</p>}
            {skills && (
              <div className="learning-skills">
                {skills.map((skill) => (
                  <span key={skill}>{skill}</span>
                ))}
              </div>
            )}
            {projects && (
              <div className="learning-projects">
                <h4>{t("certificates.capstoneProjects")}</h4>
                {projects.map((project) => (
                  <p key={project.title}>
                    <strong>{project.title}</strong>
                    <br />
                    {project.subTitle}
                  </p>
                ))}
              </div>
            )}
          </details>
        )}
        <div className="learning-evidence">
          {showCertificate && (
            <PdfModalApp certificatePath={certificatePath} courseName={title} />
          )}
          {showBadges && <BadgesModal badges={badges} courseName={title} />}
        </div>
      </div>
    </article>
  );
}
